import { render, staticRenderFns } from "./ClaimProduct.vue?vue&type=template&id=a8032af8&scoped=true&"
import script from "./ClaimProduct.vue?vue&type=script&lang=ts&"
export * from "./ClaimProduct.vue?vue&type=script&lang=ts&"
import style0 from "./ClaimProduct.vue?vue&type=style&index=0&id=a8032af8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8032af8",
  null
  
)

export default component.exports